import React, { useState } from 'react';
import { Table } from 'antd';
import Module from "../common/moduleTitle";
import arrowImg from '../../../images/analysis/arrow.png';

const defAbilityDefineList = [];
const defabilityAnalysis = '';

const Reading = ({data = {}}) => {
    const {
        abilityAnalysis = '',
        abilityDefineList = [],
        mentalityAnalysis = '',
        mentalityDefineList = [],
        personalityAnalysis = '',
        personalityDefineList = [],
    } =  data;
    const columns = [
        {
            title: '维度指标',
            dataIndex: 'abilityItem',
            key: 'abilityItem',
            width: '140px',
        },
        {
            title: '定义',
            dataIndex: 'abilityDefine',
            key: 'abilityDefine',
            className: 'reading-text',
        }
    ];
    const columns1 = [
        {
            title: '维度指标',
            dataIndex: 'mentalityItem',
            key: 'mentalityItem',
            width: '140px',
        },
        {
            title: '定义',
            dataIndex: 'mentalityDefine',
            key: 'mentalityDefine',
            className: 'reading-text',
        }
    ];

    const strFormat = str => {
        return str.padEnd(12, ' ').replace(/\s/g, '&ensp;')
    }
    
    return (
        <div className="reading">
            <div className="readingTitleWrap">
                <div className="readingTitleLeft">
                    <div className="readingTitleLeftIcon">
                        <span></span>
                        <span></span>
                    </div>
                    <span>阅读指引</span>
                </div>
                <div className="readingTitleRight">
                    {/*<span>收起</span>*/}
                    {/*<i className="iconfont icon-drop-down"></i>*/}
                </div>
            </div>

            {abilityAnalysis && <Module
                text="胜任力分析"
                enText="COMPETENCY"
                title={abilityAnalysis || ''}
            />}

            {abilityDefineList && abilityDefineList.length > 0 ? <Table
                className="readingTable"
                columns={columns}
                dataSource={abilityDefineList || []}
                pagination={false}
            /> : null}

            {/* mentalityAnalysis 心理 */}
            {mentalityAnalysis && <Module
                text="心理测验"
                enText="SHENGRENLI"
                title={mentalityAnalysis || ''}
            />}
            {/* mentalityDefineList 心理 */}
            {mentalityDefineList && mentalityDefineList.length > 0 ? <Table
                className="readingTable"
                columns={columns1}
                dataSource={mentalityDefineList || []}
                pagination={false}
            /> : null}

            {personalityAnalysis && <Module
                text="大五人格"
                enText="OCEAN"
                title={personalityAnalysis || ''}
            />}

            {personalityAnalysis && <div className="content">
                {personalityDefineList.length > 0 ? personalityDefineList.map(item => {
                    return (
                        <div className="reading-content-li">
                            {item.name}：{item.define}
                        </div>
                    )
                }) : null}
            </div>}
        </div>
    );
}

export default Reading;
